import { render, staticRenderFns } from "./CloseWarnings.vue?vue&type=template&id=1ac1895e&"
import script from "./CloseWarnings.vue?vue&type=script&lang=js&"
export * from "./CloseWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports